import { WifiOff } from "lucide-react";

/** Shown when a screen or chart cannot load because the device is offline. */
export default function NeedsConnection({
  title = "Needs a connection",
  detail = "This section couldn’t load while offline. Reconnect, or open it once while online so it stays available next time.",
  compact = false,
}: {
  title?: string;
  detail?: string;
  /** Inline placeholder for charts nested inside overview cards. */
  compact?: boolean;
}) {
  const body = (
    <div className={`empty-small needs-connection${compact ? " compact" : ""}`}>
      <WifiOff size={compact ? 22 : 28} aria-hidden />
      <h3>{title}</h3>
      <p>{detail}</p>
    </div>
  );
  if (compact) return body;
  return <section className="panel settings-panel">{body}</section>;
}
